import { ITechnicianPartial } from '../../../../../app/entities/Technician'
import { ILocationPartial } from '../../../../../app/entities/Location'

export interface TechnicianResponse {
  items?: ITechnicianPartial[]
  technicians?: ITechnicianPartial[]
  count?: number
}

export interface LocationResponse {
  items?: ILocationPartial[]
  locations?: ILocationPartial[]
  count?: number
}

/**
 * Get all locations (same endpoint used by LocationDropDown component)
 */
export function getAllLocations() {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/locations/location`,
  }
}

/**
 * Get technicians by location
 */
export function getTechniciansByLocation(locationObjectId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/technicians/location/${locationObjectId}`,
  }
}
